import { useState } from "react";


const initialNewCategory = {
  name: "",
  unitMeasurement: "",
  customUnitMeasurement: "",
  image: null,
  imagePreview: null,
};


export function useAddCategoryModal() {
  const [newCategories, setNewCategories] = useState([
    { ...initialNewCategory },
  ]);

  const handleImageUpload = (index, file) => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const updated = [...newCategories];
        updated[index].image = file;
        updated[index].imagePreview = reader.result;
        setNewCategories(updated);
      };
      reader.readAsDataURL(file);
    }
  };

  const addAnotherCategory = () => {
    setNewCategories([...newCategories, { ...initialNewCategory }]);
  };

  const removeCategory = (index) => {
    if (newCategories.length > 1) {
      setNewCategories(newCategories.filter((_, i) => i !== index));
    }
  };

  const resetCategories = () => {
    setNewCategories([{ ...initialNewCategory }]);
  };

  const getValidCategories = () => {
    return newCategories.filter((c) => {
      if (!c.name.trim()) return false;
      if (c.unitMeasurement === "Custom") {
        return c.customUnitMeasurement.trim() !== "";
      }
      return c.unitMeasurement !== "";
    });
  };

  return {
    newCategories,
    setNewCategories,
    handleImageUpload,
    addAnotherCategory,
    removeCategory,
    resetCategories,
    getValidCategories,
  };
}
